<div class="row">
  <div class="col-8">

  </div>
<div style="width: 40%" class="box-parent col-4">
   <div class="dropdown-label-group">
      <p-dropdown [options]="dashboards"
                  [(ngModel)]="selectDashboard"
                  class="dv-dropdown"
                  selectId="year"
                  placeholder="{{'DOC-DASHBOARD.DASHBOARDLIST' | translate}}"
                  (onChange)="choosedashboard()"

      >
      </p-dropdown>
   <label for="customercode">{{'DOC-DASHBOARD.DASHBOARDLIST' | translate}}</label>

   </div>

     </div>
</div>


 <div [ngSwitch]="keepdashboard" >
   <div *ngSwitchCase="null" class="mt-2">
     <app-dashboard-document></app-dashboard-document>
   </div>


        <div *ngSwitchCase="2" >
          <div style="margin-top: -30px">
            <app-dashboard-sms></app-dashboard-sms>

          </div>
        </div>
   <div *ngSwitchCase="3">
     <div>
       <app-email-dashboard></app-email-dashboard>
     </div>
   </div>
   <div *ngSwitchCase="4">
     <div>
       <app-document-request-dashboard></app-document-request-dashboard>
     </div>
   </div>
   <div *ngSwitchCase="5">
     <div>
       <app-dashboard-storage></app-dashboard-storage>
     </div>
   </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-list/dashboard-list.component.html